export default "/images/dbf8b3fbdc607d4f888a10bf82790356.avif";